module.exports = __webpack_public_path__ + "51ded43cb59e896acd318edbcfcae1a0.png";